import * as React from 'react';
import { createRoot } from 'react-dom/client';
import App from './CustomerPortal.js';

const container = document.getElementById('app');

if (!container) throw new Error('No container with the id "app" found');

const root = createRoot(container);

root.render(<App />);
